'use client';
import React from 'react';
import { ImageGalleryFullscreen as Shared } from '@launchstore/shared-puck';
import { useProduct } from '@/lib/hooks/useProduct';
import type { ProductDataImage } from '@launchstore/shared-puck';

const SharedRender = (Shared as any).render;

const ImageGalleryFullscreenImpl: React.FC<any> = (props: any) => {
  const { product } = useProduct() as any;
  const images: ProductDataImage[] = (product?.images || []).map((img: any, i: number) => ({
    id: img.id || String(i),
    url: img.url,
    alt: img.alt || `${product?.title || 'Product'} - Image ${i + 1}`,
  }));
  // Only inject when there are real images so the Puck editor still shows the preview placeholders.
  return <SharedRender {...(props as any)} {...(images.length ? { images } : {})} productTitle={product?.title} />;
};

export const ImageGalleryFullscreen: any = { ...Shared, render: (props: any) => <ImageGalleryFullscreenImpl {...props} /> };
export default ImageGalleryFullscreen;
